import Router from 'next/router';
import nProgress from 'nprogress'; //nprogress module

export const init = (): void => {
  nProgress.configure({ showSpinner: false });
  Router.events.on('routeChangeStart', () => nProgress.start());
  Router.events.on('routeChangeComplete', () => nProgress.done());
  Router.events.on('routeChangeError', () => nProgress.done());
};
